import { type Options, type Splide } from "@splidejs/splide"

export async function useSplide(target: string | HTMLElement, options?: Options) {
  let splide: Splide | null = null
  if (target instanceof HTMLElement) {
    const { default: BaseSplide } = await import('@splidejs/splide')
    splide = new BaseSplide(target, options)
  } else if (typeof target === 'string') {
    const { default: BaseSplide } = await import('@splidejs/splide')
    const splideElement = document.querySelector<HTMLElement>(target)
    if (splideElement) {
      splide = new BaseSplide(splideElement, options)
    }
  }
  return splide
}